import * as React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { selectBuildingsByModalTabId } from "../../../selectors/selectExistingBuildingInfo";
import { selectModalTabId } from "../../../selectors/selectModalTabId";
import { GridContainer } from "../../generic/grid-layout/GridContainer";
import { IdModal } from "../../modals/IdModal";
import { IdShowMeFeature } from "../../show-me/IdShowMeFeature";
import { actionBuildingsSelectBeforePlacement } from "./actionBuildings";
import { GridItemBuilding } from "./GridItemBuilding";
var _MasterViewBuildings = function (_a) {
    var buildings = _a.buildings, selectBuilding = _a.selectBuilding, onSelect = _a.onSelect, showMeBuildingInfo = _a.showMeBuildingInfo, tabId = _a.tabId;
    var getSelectedIndex = function () {
        if (showMeBuildingInfo && !showMeBuildingInfo.isConsumed) {
            var buildingIndex = buildings.findIndex(function (building) { return building.id === showMeBuildingInfo.buildingId; });
            if (buildingIndex !== -1) {
                return buildingIndex;
            }
        }
        return 0;
    };
    var _b = useState(getSelectedIndex()), selectedItemIndex = _b[0], setSelectedItemIndex = _b[1];
    var _c = useState(tabId), selectedTabId = _c[0], setSelectedTabId = _c[1];
    if (tabId !== selectedTabId) {
        setSelectedItemIndex(0);
        setSelectedTabId(tabId);
    }
    var onBuildingSelect = function (index) {
        setSelectedItemIndex(index);
        var building = buildings[index];
        if (building) {
            var data = {
                balancing: building,
                proto: { stage: building.stageId || 1 },
            };
            selectBuilding(data);
            if (onSelect) {
                onSelect(building);
            }
        }
    };
    useEffect(function () {
        if (showMeBuildingInfo && showMeBuildingInfo.isConsumed) {
            return;
        }
        var newIndex = getSelectedIndex();
        onBuildingSelect(newIndex !== -1 ? newIndex : 0);
    }, [showMeBuildingInfo]);
    return (React.createElement("div", { className: "build-menu__master-view" },
        React.createElement(GridContainer, { items: buildings, gridItemRenderer: GridItemBuilding, onSelect: onBuildingSelect, selectedIndex: selectedItemIndex, key: tabId })));
};
var mapState = function (state) { return ({
    buildings: selectBuildingsByModalTabId(state),
    showMeBuildingInfo: state.showMe[IdShowMeFeature.BuildingMenu],
    tabId: selectModalTabId(state, IdModal.BuildingList) || 0,
}); };
var mapDispatch = function (dispatch) { return ({
    selectBuilding: function (building) {
        return dispatch(actionBuildingsSelectBeforePlacement(building));
    },
}); };
export var MasterViewBuildings = connect(mapState, mapDispatch)(_MasterViewBuildings);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/MasterViewBuildings.tsx
// module id = 939
// module chunks = 3